import { useState, useEffect } from "react";
import { loadCOList } from "../../../services/SalesService";
import dayjs from "dayjs";

const useCOAvailableGForDespatchPlan = ( showError,) => {
    const [coList, setCoList] = useState([]);

    const getCOAvailableListByDataRange = async (fromDate, toDate, bill_to_party = 0, co = null, prodStatus = null, finacial_year) => {

        if (!fromDate) {
            showError("Please select the from date", "warning");
            return;
        }
        if (!toDate) {
            showError("Please select the to date", "warning");
            return;
        }
        let bill_to_party_val=0
        if (bill_to_party!==''){
            bill_to_party_val=bill_to_party
        }

        const formattedFromDate = dayjs(fromDate).format("DD/MMM/YYYY");
        const formattedToDate = dayjs(toDate).format("DD/MMM/YYYY");
        
        const para = {
            p_from_confirmation_date: formattedFromDate,
            p_to_confirmation_date: formattedToDate,
            p_company_id: localStorage.getItem("companyid"),
            p_plant_id: 1,
            p_finyear_id: finacial_year,
            p_billtocustomer: bill_to_party_val,
            p_cono: co,
            p_maprodstatus: prodStatus,
            p_currentuser: 'user',
        };

        try {
            const data = await loadCOList(para);
            if (data && data.length > 0) {
                setCoList(data[0].material_code); // Assumes backend returns `material_code`
            }
        } catch (error) {
            console.error("Failed to generate material code:", error);
        }
    };

    return {
        coList,
        setCoList,
        getCOAvailableListByDataRange,
    };
};

export default useCOAvailableGForDespatchPlan;
